var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyZar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136729)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136729)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -2,
    width: 46.1222,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.99641 -2.00042H43.1257V13.3389H20.0647L-2.99641 -2.00042Z",
    fill: "#E03C31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.99641 28.6781H43.1257L43.1257 13.3389H20.0647L-2.99641 28.6781Z",
    fill: "#001489"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.12109 -11.564L21.6134 8.21417H43.1257V18.4635H21.6134L-8.12109 38.2417V-11.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.99641 -2.00042L20.0647 13.3389L-2.99641 28.6781V-2.00042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5128 13.3389L-4.69933 0.55976L-1.29349 -4.5606L20.9939 10.264H43.1257V16.4137H20.9939L-1.29349 31.2383L-4.69933 26.1179L14.5128 13.3389Z",
    fill: "#007749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.69933 0.55976L14.5128 13.3389L-4.69933 26.1179L-5.83461 24.4111L10.8115 13.3388L-5.83461 2.26652L-4.69933 0.55976Z",
    fill: "#FFB81C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136729"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -2,
    width: 46.1222,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyZar);
export default __webpack_public_path__ + "static/media/Currency=ZAR.34dc3b3bdce2468dd4dd539496b82868.svg";
export { ForwardRef as ReactComponent };